import store from '@/store'

function getTokenBeforeCaret(text, pos) {
  const before = text.slice(0, pos)
  const m = before.match(/(?:\s|^)(@[-_A-Za-z0-9]+)$/)
  if (!m) return null
  const token = m[1]
  const start = pos - token.length
  return { start, token }
}

function replaceInInput(el, start, end, replacement) {
  const before = el.value.slice(0, start)
  const after = el.value.slice(end)
  el.value = before + replacement + after
  const caret = before.length + replacement.length
  el.setSelectionRange(caret, caret)
  el.dispatchEvent(new Event('input', { bubbles: true }))
}

function replaceInContentEditable(selection, tokenRange, replacement) {
  const range = tokenRange.cloneRange()
  range.deleteContents()
  const textNode = document.createTextNode(replacement)
  range.insertNode(textNode)
  const r = document.createRange()
  r.setStartAfter(textNode)
  r.collapse(true)
  selection.removeAllRanges()
  selection.addRange(r)
}

async function getShortcuts() {
  let items = store.getters['keyboardshortcuts/getAllShortcuts']?.() || []
  if (!items.length) {
    try {
      await store.dispatch('keyboardshortcuts/fetchShortcuts')
      items = store.getters['keyboardshortcuts/getAllShortcuts']?.() || []
    } catch (err) {
      return []
    }
  }
  return items
}

function currentUserId() {
  return store.state.auth?.current?.id || null
}

export const shortcutExpand = {
  bind(el) {
    // Use event delegation: listen on el, check e.target in handler.
    // keyup bubbles so this works for both native elements and wrapper components
    // (e.g. speech-area wrapping a b-form-textarea wrapping a textarea).
    const handler = async (e) => {
      const key = e.key || ''
      if (key !== ' ' && (e.keyCode !== 32)) return

      const activeEl = e.target

      if (activeEl instanceof HTMLInputElement || activeEl instanceof HTMLTextAreaElement) {
        // When keyup fires the space character is already inserted and the caret
        // sits after it. Look one position back to find the @token.
        const pos = activeEl.selectionStart || 0
        if (pos < 2) return
        const found = getTokenBeforeCaret(activeEl.value, pos - 1)
        if (!found) return
        const code = found.token.slice(1).toLowerCase()
        if (!code || code === 'pr') return

        const items = await getShortcuts()
        const match = items.find(s => s.is_active && (s.is_public || (s.user && s.user.id === currentUserId())) && (s.keys || '').toLowerCase() === code)
        if (!match) return

        // Replace token + the space just typed (found.start → pos) with description + space
        replaceInInput(activeEl, found.start, pos, match.description + ' ')
      } else {
        // contenteditable: space already in text node; offset is after the space
        const sel = window.getSelection()
        if (!sel || sel.rangeCount === 0) return
        const range = sel.getRangeAt(0)
        const node = range.startContainer
        const offset = range.startOffset
        if (!node || node.nodeType !== Node.TEXT_NODE) return
        if (offset < 2) return
        const text = node.textContent || ''
        // Look before the trailing space (offset - 1)
        const found = getTokenBeforeCaret(text, offset - 1)
        if (!found) return
        const code = found.token.slice(1).toLowerCase()
        if (!code || code === 'pr') return

        const items = await getShortcuts()
        const match = items.find(s => s.is_active && (s.is_public || (s.user && s.user.id === currentUserId())) && (s.keys || '').toLowerCase() === code)
        if (!match) return

        // Replace token + space (tokenStart → offset)
        const tokenStart = (offset - 1) - found.token.length
        const tokenRange = document.createRange()
        tokenRange.setStart(node, tokenStart)
        tokenRange.setEnd(node, offset)

        replaceInContentEditable(sel, tokenRange, match.description + ' ')
      }
    }

    el.__shortcutExpandHandler = handler
    el.addEventListener('keyup', handler)
  },
  unbind(el) {
    if (el.__shortcutExpandHandler) {
      el.removeEventListener('keyup', el.__shortcutExpandHandler)
      delete el.__shortcutExpandHandler
    }
  }
}

export default shortcutExpand
